import Header from "../components/Header";
import Footer from "../components/Footer";
// import RightSidebar from "../components/RightSidebar";
import { Outlet } from "react-router-dom";
import RightOverlaySidebar from "../components/RightOverlaySidebar";
import LeftSidebar from "../components/LeftSidebar";

const MainLayout = () => {
  return (
    <div className="app-container">
      <Header />
      <div className="content-wrapper">
        <LeftSidebar />
        <main className="main-content">
          <Outlet />
        </main>
        {/* <RightSidebar /> */}
      </div>
      <Footer />
      {/* Overlay sidebar (slides over content) */}
      <RightOverlaySidebar />
    </div>
  );
};

export default MainLayout;
